import { render, staticRenderFns } from "./users_new.vue?vue&type=template&id=2fb99c98"
import script from "./users_new.vue?vue&type=script&lang=js"
export * from "./users_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports